import defaults from "lodash/defaults";
import pick from "lodash/pick";
import { type QueryParamConfig, decodeNumber, decodeString, encodeNumber, encodeString } from "serialize-query-params";

import { toKeys } from "~/tools/to-keys";

const OptionalNumberParam: QueryParamConfig<number | undefined> = {
	encode: (value) => encodeNumber(value) || undefined,
	decode: (value) => decodeNumber(value) || undefined,
};

const OptionalStringParam: QueryParamConfig<string | undefined> = {
	encode: (value) => encodeString(value) || undefined,
	decode: (value) => decodeString(value) || undefined,
};

export abstract class NotificationsState {
	readonly channelId?: number;

	readonly tempId?: string;

	readonly error?: string;

	static readonly searchParams = {
		channelId: OptionalNumberParam,
		tempId: OptionalStringParam,
		error: OptionalStringParam,
	};

	static readonly defaults: NotificationsState = {
		channelId: undefined,
		tempId: undefined,
		error: undefined,
	};

	static withDefaults<TState extends Partial<NotificationsState>>(
		state: undefined | null | TState,
	): NotificationsState {
		return defaults({}, pick(state, toKeys(NotificationsState.defaults)), NotificationsState.defaults);
	}
}
